module.exports = __webpack_public_path__ + "static/img/16.e00d64c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/zh/16.png
// module id = L7Uw
// module chunks = 0